// src/contexts/LookupContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import {
  getRekeningOptions,
  getPersediaanDetailOptions,
  getBarangDetailOptions,
  getSatuanDetailOptions,
} from "../services/lookupService";
import { AuthContext } from "./AuthContext";

const LookupContext = createContext();

export const LookupProvider = ({ children }) => {
  const { user } = useContext(AuthContext);

  const [rekeningOptions, setRekeningOptions] = useState([]);
  const [persediaanOptions, setPersediaanOptions] = useState([]);
  const [satuanOptions, setSatuanOptions] = useState([]);
  const [barangOptions, setBarangOptions] = useState([]);

  useEffect(() => {
    if (!user) return; // hanya fetch jika user login

    const fetchLookups = async () => {
      try {
        const [rek, pers, satuan, barang] = await Promise.all([
          getRekeningOptions(),
          getPersediaanDetailOptions(),
          getSatuanDetailOptions(),
          getBarangDetailOptions(),
        ]);
        setRekeningOptions(rek);
        setPersediaanOptions(pers);
        setSatuanOptions(satuan);
        setBarangOptions(barang);
      } catch (err) {
        console.error("Gagal fetch lookup data:", err);
      }
    };

    fetchLookups();
  }, [user]);

  return (
    <LookupContext.Provider
      value={{
        rekeningOptions,
        persediaanOptions,
        satuanOptions,
        barangOptions,
      }}
    >
      {children}
    </LookupContext.Provider>
  );
};

export const useLookup = () => useContext(LookupContext);
